module.exports = __webpack_public_path__ + "img/logo.d3267a88.png";